import requests from "./httpService";

const RelatedToServices = {
  getRelatedToServices(body) {
    return requests.get(`/related-to/all?company_id=${body}`, body);
  },
  deleteRelatedToServices(id, body) {
    return requests.delete(`/related-to/${id}`, body);
  },
  createRelatedTo(body) {
    return requests.post(`/related-to/create`, body);
  },
  editRelatedTo(id, body) {
    return requests.post(`/related-to/update/${id}`, body);
  },
  statusChange(id, body) {
    return requests.post(`/related-to/statusupdate/${id}`, body);
  },
};

export default RelatedToServices;
